module.exports = __webpack_public_path__ + "static/img/plan3.a6c3e79.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/after-bootcamp/benjyfishy/training-plan/plan3.png
// module id = 93L4
// module chunks = 35